import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResourcePage } from './Aid';

export default function EconomyPage() {
  const { t } = useTranslation();

  return (
    <ResourcePage
      resourceType="economy"
      pageTitle={t('Economy overview')}
      pageDescription="Official economic reports, policy material and resources from the Ministry of Finance."
    />
  );
}


